export default "__VITE_ASSET__DPWlD5$h__"